import React from 'react';

// The privacy notice, cookie policy and terms are maintained on the main site and linked to
// from every subdomain, so there is one copy of each rather than one per surface.
const MAIN_SITE = 'https://www.trustline.id';

/** The Terms of Service a client accepts (on the main site; to be updated). */
export const TERMS_URL = `${MAIN_SITE}/website-terms`;

/**
 * Shared footer for every route.
 *
 * Each page carried its own copy of this markup, and the routes that are commented out of the
 * router carried one too, so a change made in one place reached some pages and not others.
 * One component means the legal links cannot go missing from a page again.
 */
const SiteFooter: React.FC = () => (
  <footer>
    <p>Contact us at <a href="mailto:contact@trustline.id">contact@trustline.id</a></p>
    <p>
      <a href={`${MAIN_SITE}/privacy-policy`} target="_blank" rel="noopener noreferrer">
        Privacy notice
      </a>
      {' · '}
      <a href={`${MAIN_SITE}/cookie-policy`} target="_blank" rel="noopener noreferrer">
        Cookies and storage
      </a>
      {' · '}
      <a href={TERMS_URL} target="_blank" rel="noopener noreferrer">
        Terms
      </a>
    </p>
  </footer>
);

export default SiteFooter;
